import { gsap } from 'gsap'
import { portfolio } from './blocks'
//import { ScrollTrigger } from 'gsap/ScrollTrigger'
//import { CSSPlugin } from 'gsap/CSSPlugin'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		let listener = false
		//gsap.registerPlugin(ScrollTrigger)
		//gsap.registerPlugin(CSSPlugin)

		// prevent pagescrolling when lightbox is opened
		$(document).on('lity:close', function (event, instance) {
			$('html').css('overflow', 'initial')
		})

		$(document).on('lity:open', function (event, instance) {
			$('html').css('overflow', 'hidden')
			gsap.from('.portfolio-popup-bottom', {
				autoAlpha: 0,
				duration: 0.5,
				ease: 'power1.out',
			})
			gsap.from('.portfolio-logo, .portfolio-popup-top-info', {
				// scale: 0.96,
				autoAlpha: 0,
				duration: 0.35,
				ease: 'power1.out',
				// stagger: 0.02,
			})
		})

		document.addEventListener('click', closeMenus)

		function closeMenus(e) {
			if (
				(e.target.id &&
					e.target.id != 'filter-sector-dt' &&
					e.target.id != 'filter-status-dt') ||
				(!e.target.id && !e.target.classList.contains('multiSel'))
			) {
				let menus = document.getElementsByClassName('dropdown')
				//console.log(menus);
				let iter

				for (iter = 0; iter < menus.length; iter++) {
					if (menus[iter].querySelector('dt').classList.contains('open')) {
						menus[iter].querySelector('dt').classList.remove('open')
						//console.log(menus[iter].querySelector('.multiSelect ul'));
						menus[iter]
							.querySelector('.multiSelect ul')
							.classList.remove('dd-open')
						menus[iter].querySelector('.nav-indicator').classList.remove('show')
					}
				}
			}
		}

		document
			.getElementById('filter-sector')
			.addEventListener('click', function () {
				// close element if click is outside once opened
				//		if (listener) {
				//			document.removeEventListener('click', clickaway);
				//			listener = false;
				//		}
				//		document.addEventListener('click', function clickaway(e) {
				//			if (!document.getElementById('filter-sector').contains(e.target)) {
				//				this.querySelector('dt').classList.remove('open');
				//				this.querySelector('.multiSelect ul').style.display = 'none';
				//				this.querySelector('.nav-indicator').classList.remove('show');
				//			}
				//			listener = true;
				//		});

				let fists = document.getElementById('filter-status')
				if (fists.querySelector('dt').classList.contains('open')) {
					fists.querySelector('dt').classList.remove('open')
					if (
						fists.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fists.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fists.querySelector('.nav-indicator').classList.contains('show')
					) {
						fists.querySelector('.nav-indicator').classList.remove('show')
					}
				}
				let fisec2 = document.getElementById('filter-source')
				if (fisec2.querySelector('dt').classList.contains('open')) {
					fisec2.querySelector('dt').classList.remove('open')
					if (
						fisec2.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fisec2.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fisec2.querySelector('.nav-indicator').classList.contains('show')
					) {
						fisec2.querySelector('.nav-indicator').classList.remove('show')
					}
				}

				//toggle dt
				let dt = this.querySelector('dt')
				let msul = this.querySelector('.multiSelect ul')
				let navi = this.querySelector('.nav-indicator')

				if (dt.classList.contains('open')) {
					dt.classList.remove('open')
				} else {
					dt.classList.add('open')
				}

				if (!msul.classList.contains('dd-open')) {
					msul.classList.add('dd-open')
				} else {
					msul.classList.remove('dd-open')
				}

				if (navi.classList.contains('show')) {
					navi.classList.remove('show')
				} else {
					navi.classList.add('show')
				}
			})

		document
			.getElementById('filter-status')
			.addEventListener('click', function () {
				//	if (listener || clickaway == null) {
				//		document.removeEventListener('click', clickaway);
				//		listener = false;
				//	}
				//	// close element if click is outside once opened
				//	document.addEventListener('click', function clickaway(e) {
				//		if (!document.getElementById('filter-status').contains(e.target)) {
				//			this.querySelector('dt').classList.remove('open');
				//			this.querySelector('.multiSelect ul').style.display = 'none';
				//			this.querySelector('.nav-indicator').classList.remove('show');
				//		}
				//		listener = true;
				//	});

				let fisec = document.getElementById('filter-sector')
				if (fisec.querySelector('dt').classList.contains('open')) {
					fisec.querySelector('dt').classList.remove('open')
					if (
						fisec.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fisec.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fisec.querySelector('.nav-indicator').classList.contains('show')
					) {
						fisec.querySelector('.nav-indicator').classList.remove('show')
					}
				}
				let fisec2 = document.getElementById('filter-source')
				if (fisec2.querySelector('dt').classList.contains('open')) {
					fisec2.querySelector('dt').classList.remove('open')
					if (
						fisec2.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fisec2.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fisec2.querySelector('.nav-indicator').classList.contains('show')
					) {
						fisec2.querySelector('.nav-indicator').classList.remove('show')
					}
				}

				//toggle dt
				let dt = this.querySelector('dt')
				let msul = this.querySelector('.multiSelect ul')
				let navi = this.querySelector('.nav-indicator')

				if (dt.classList.contains('open')) {
					dt.classList.remove('open')
				} else {
					dt.classList.add('open')
				}

				if (!msul.classList.contains('dd-open')) {
					msul.classList.add('dd-open')
				} else {
					msul.classList.remove('dd-open')
				}

				if (navi.classList.contains('show')) {
					navi.classList.remove('show')
				} else {
					navi.classList.add('show')
				}
			})
		document
			.getElementById('filter-source')
			.addEventListener('click', function () {
				//	if (listener || clickaway == null) {
				//		document.removeEventListener('click', clickaway);
				//		listener = false;
				//	}
				//	// close element if click is outside once opened
				//	document.addEventListener('click', function clickaway(e) {
				//		if (!document.getElementById('filter-status').contains(e.target)) {
				//			this.querySelector('dt').classList.remove('open');
				//			this.querySelector('.multiSelect ul').style.display = 'none';
				//			this.querySelector('.nav-indicator').classList.remove('show');
				//		}
				//		listener = true;
				//	});

				let fisec = document.getElementById('filter-sector')
				if (fisec.querySelector('dt').classList.contains('open')) {
					fisec.querySelector('dt').classList.remove('open')
					if (
						fisec.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fisec.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fisec.querySelector('.nav-indicator').classList.contains('show')
					) {
						fisec.querySelector('.nav-indicator').classList.remove('show')
					}
				}
				let fisec2 = document.getElementById('filter-status')
				if (fisec2.querySelector('dt').classList.contains('open')) {
					fisec2.querySelector('dt').classList.remove('open')
					if (
						fisec2.querySelector('.multiSelect ul').classList.contains('dd-open')
					) {
						fisec2.querySelector('.multiSelect ul').classList.remove('dd-open')
					}
					if (
						fisec2.querySelector('.nav-indicator').classList.contains('show')
					) {
						fisec2.querySelector('.nav-indicator').classList.remove('show')
					}
				}

				//toggle dt
				let dt = this.querySelector('dt')
				let msul = this.querySelector('.multiSelect ul')
				let navi = this.querySelector('.nav-indicator')

				if (dt.classList.contains('open')) {
					dt.classList.remove('open')
				} else {
					dt.classList.add('open')
				}

				if (!msul.classList.contains('dd-open')) {
					msul.classList.add('dd-open')
				} else {
					msul.classList.remove('dd-open')
				}

				if (navi.classList.contains('show')) {
					navi.classList.remove('show')
				} else {
					navi.classList.add('show')
				}
			})

		$('footer').css('opacity', 0)
		setTimeout(() => {
			window.scrollTo(0, 0)
			$('footer').animate({
				opacity: 1,
				}, 200, function() {
				// Animation complete.
				});
		}, 350)
	},
	finalize() {


		/* Load in grid via ajax */
		let httpRequest = new XMLHttpRequest()
		httpRequest.onreadystatechange = function () {

			if (this.readyState == 4 && this.status == 200) {
				document.getElementById('grid').innerHTML = this.responseText
				portfolio()
			}
		}

		httpRequest.open(
			'GET',
			'/wp-content/themes/sagard/templates/portfolio-grid.php?type=' + document.getElementsByTagName('html')[0].getAttribute('lang')
		)
		httpRequest.send()
	},
}

